export const isDatabaseError = (error: any): boolean => {
  if (error && 'type' in error && 'message' in error) return true;

  return false;
};
